module.exports = __webpack_public_path__ + "static/hexa_respect-16135edec1893cfcc0a4fc2d599d934f.svg";